module.exports = __webpack_public_path__ + "media/images/warning-cc6c61d027fcbb245232ab5998f9d88c.png";